var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoPlayCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "510px",
    height: "510px",
    viewBox: "0 0 510 510",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video-play-circle",
    transform: "translate(7.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.7,230 L187.7,123 C171.9,114.2 152,125.5 152,144 L152,352 C152,370.4 171.8,381.8 187.7,373 L363.7,272 C380.1,262.9 380.1,239.2 363.7,230 Z M496,248 C496,111 385,0 248,0 C111,0 0,111 0,248 C0,385 111,496 248,496 C385,496 496,385 496,248 Z M48,248 C48,137.5 137.5,48 248,48 C358.5,48 448,137.5 448,248 C448,358.5 358.5,448 248,448 C137.5,448 48,358.5 48,248 Z",
    id: "Shape"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayCircle);
export default __webpack_public_path__ + "static/media/video-play-circle.8ed67522.svg";
export { ForwardRef as ReactComponent };